import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import classes from './CollectionSearchBar.module.scss';
import { TextField } from '@/components';
import FilterSearchButton from '@/components/ReferralsList/FilterSearchButton/FilterSearchButton';
import { viewportContext } from '@/context/viewport.context';

const CollectionSearchBar = ({ placeholder, inputId, controlId, doSearch, setSearchText, onClear }) => {
  const { isMobileOrTablet } = useContext(viewportContext);

  const textFieldConfig = useMemo(
    () => ({
      placeholder,
      type: 'default',
      shape: 'pill',
      subtype: 'left',
      ...(isMobileOrTablet
        ? {}
        : {
            icon: {
              style: 'fas',
              font: 'search',
              additionalSearchBoxIconClass: classes.searchBoxIconClass
            }
          }),
      clear: true,
      id: inputId,
      additionalClasses: classes.searchTextFieldBox
    }),
    [placeholder, inputId, isMobileOrTablet]
  );

  return (
    <Form className="form-inline" onSubmit={doSearch}>
      <Form.Group controlId={controlId}>
        <div className={classes.searchRow}>
          <div className={classes.searchField}>
            <TextField {...textFieldConfig} onChange={setSearchText} onClear={onClear} />
          </div>
          <div className={classes.searchButton}>
            <FilterSearchButton doSearch={doSearch} hideTextOnMobile />
          </div>
        </div>
      </Form.Group>
    </Form>
  );
};

CollectionSearchBar.propTypes = {
  placeholder: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  controlId: PropTypes.string.isRequired,
  doSearch: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default CollectionSearchBar;
